import AxiosClient from "../../../../services/axios.services";

class WFlowEmpleadosServices {
  
  getEmployeeWorkFlow = params =>
    AxiosClient.get(`/api/app/On_off_bording_workflow/`, {
      headers: { "Content-Type": "application/json" },
      params: params,
    });

  saveWorkFlowEmp = data =>
    AxiosClient.post("/api/app/Onoff_boarding_grabar/", data, {
      headers: { "Content-Type": "application/json" },
    });

  editWorkFlowEmp = (id, data) =>
    AxiosClient.put(`/api/app/Onoff_boarding_grabar/${id}/`, data, {
      headers: { "Content-Type": "application/json" },
    });

  deleteWorkFlowEmp = id =>
    AxiosClient.delete(`/api/app/Onoff_boarding_grabar/${id}/`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new WFlowEmpleadosServices();
